import ChannelsAdmin from 'models/location/channels_admin';
import OpenChannelsAdmin from 'actions/channels/open_channels_admin';
import { registerUrlConverter } from './location_url';
import StaticUrlConverter from './url_converters/static_url_converter';

registerUrlConverter(ChannelsAdmin, StaticUrlConverter.create('/channels'));

export default function(router, { runnerContext }) {
  return {
    on() {
      const queryParams = router.parseQueryParameters().toJS();
      let attrs = {};
      if (queryParams.section) {
        attrs.section = queryParams.section;
      }
      runnerContext.executeAction(OpenChannelsAdmin, attrs);
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/channel_routes.js